// extracted by mini-css-extract-plugin
export var testimonialSectionBox = "testimonialVideoSection-module--testimonialSectionBox--9HinF";
export var testimonialVideoIframe = "testimonialVideoSection-module--testimonialVideoIframe--WTEfR";